import EmptyProject from '../../src/legacy/EmptyProject';
export default EmptyProject;
